import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiPlay, FiShield } = FiIcons;

const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-gray-900 via-purple-900 to-gray-900">
      {/* Video Background */}
      <div className="absolute inset-0 z-0">
        <video
          className="w-full h-full object-cover"
          autoPlay
          loop
          muted
          playsInline
        >
          <source src="https://s3.us-east-1.wasabisys.com/lrcstv/CDN/LRCS-Hero.mp4" type="video/mp4" />
        </video>
        {/* Purple gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-br from-gray-900/80 via-purple-900/70 to-gray-900/80 z-10"></div>
      </div>

      {/* Animated background elements */}
      <div className="absolute inset-0 z-20">
        <div className="absolute top-20 left-10 w-2 h-2 bg-[#ffc700] rounded-full animate-pulse"></div>
        <div className="absolute top-40 right-20 w-1 h-1 bg-purple-400 rounded-full animate-ping"></div>
        <div className="absolute bottom-32 left-1/4 w-1 h-1 bg-cyan-400 rounded-full animate-pulse"></div>
      </div>

      <div className="container mx-auto px-6 text-center relative z-30">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="max-w-4xl mx-auto"
        >
          <motion.h1
            className="text-5xl md:text-7xl font-bold mb-6 bg-gradient-to-r from-[#ffc700] via-purple-500 to-cyan-400 bg-clip-text text-transparent"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.2, duration: 0.8 }}
          >
            Scammers, Meet Your Match.
          </motion.h1>

          <motion.p
            className="text-xl md:text-2xl mb-8 text-gray-300 font-medium"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4, duration: 0.8 }}
          >
            I'm Linda Roberts, and I call scammers so you don't have to.
          </motion.p>

          <motion.div
            className="flex flex-col sm:flex-row gap-4 justify-center items-center"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6, duration: 0.8 }}
          >
            <a
              href="http://link.lrcs.nyc/YTSL"
              target="_blank"
              rel="noopener noreferrer"
              className="group bg-gradient-to-r from-[#ffc700] to-[#ffb700] hover:from-[#ffb700] hover:to-[#ffa700] text-black px-8 py-4 rounded-full font-bold text-lg transition-all duration-300 transform hover:scale-105 flex items-center gap-3 shadow-lg hover:shadow-[#ffc700]/25"
            >
              <SafeIcon icon={FiPlay} className="text-xl group-hover:animate-pulse" />
              Watch on YouTube
            </a>

            <a
              href="https://www.youtube.com/@LindaRobertsCallsScammers/membership"
              target="_blank"
              rel="noopener noreferrer"
              className="group bg-transparent border-2 border-[#ffc700] hover:bg-[#ffc700] hover:text-black text-[#ffc700] px-8 py-4 rounded-full font-bold text-lg transition-all duration-300 transform hover:scale-105 flex items-center gap-3"
            >
              <SafeIcon icon={FiShield} className="text-xl group-hover:rotate-12 transition-transform" />
              Join the Fight
            </a>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;